<div
  class="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-cover bg-center"
  style="background-image: url('/login_background1.jpg')"
>
  <div class="pointer-events-none absolute inset-0 bg-slate-900/72"></div>

  <div class="relative z-10 flex w-full flex-col items-center px-4">
    <img class="mb-8 h-10 w-auto" src="/Aksia_Logo_white.png" alt="Aksia" />

    @if (!paramsValid()) {
      <p class="mb-5 max-w-xs text-center text-sm text-white/80">
        This link is incomplete. Please use the original link from your email,
        or request a new one.
      </p>
      <button
        type="button"
        class="rounded-lg bg-slate-100/95 px-6 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-200"
        (click)="goToForgotPassword()"
      >
        Request a new link
      </button>
    } @else if (outcome() === 'form') {
      <ul class="mb-3 w-full max-w-[19rem] space-y-0.5 text-left">
        @for (rule of policyRules(); track rule.label) {
          <li
            class="flex items-center gap-1.5 text-[10px] transition-colors duration-200"
            [class.text-emerald-400]="rule.met"
            [class.text-white/45]="!rule.met"
          >
            <span class="w-3 text-center font-bold">{{
              rule.met ? '✓' : '○'
            }}</span>
            {{ rule.label }}
          </li>
        }
      </ul>

      <form (submit)="submit($event)" novalidate>
        <div
          class="flex rounded-lg overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.4)]"
          [class.form-shake]="formShaking()"
        >
          <div class="flex flex-col bg-white/95">
            <div
              class="flex w-60 items-center border-b border-slate-200"
              style="
                transition:
                  border-bottom-color 200ms ease,
                  border-bottom-width 150ms ease;
              "
              [style.borderBottomColor]="
                showNewPasswordError() || mismatchError()
                  ? '#c0392b'
                  : undefined
              "
              [style.borderBottomWidth]="
                showNewPasswordError() || mismatchError() ? '2px' : undefined
              "
            >
              <input
                class="min-w-0 flex-1 border-0 bg-transparent py-2.5 pl-3 text-sm text-slate-900 outline-none placeholder:text-slate-400"
                [type]="newPasswordVisible() ? 'text' : 'password'"
                autocomplete="new-password"
                placeholder="New password"
                maxlength="64"
                [value]="newPassword()"
                (input)="updateNewPassword($any($event.target).value)"
              />
              <button
                type="button"
                class="pr-3 text-xs font-medium text-slate-500 transition hover:text-slate-800"
                (click)="newPasswordVisible.set(!newPasswordVisible())"
              >
                {{ newPasswordVisible() ? 'Hide' : 'Show' }}
              </button>
            </div>

            <div class="flex w-60 items-center">
              <input
                class="min-w-0 flex-1 border-0 bg-transparent py-2.5 pl-3 text-sm text-slate-900 outline-none placeholder:text-slate-400"
                [type]="confirmPasswordVisible() ? 'text' : 'password'"
                autocomplete="new-password"
                placeholder="Confirm password"
                maxlength="64"
                [value]="confirmPassword()"
                (input)="confirmPassword.set($any($event.target).value)"
              />
              <button
                type="button"
                class="pr-3 text-xs font-medium text-slate-500 transition hover:text-slate-800"
                (click)="confirmPasswordVisible.set(!confirmPasswordVisible())"
              >
                {{ confirmPasswordVisible() ? 'Hide' : 'Show' }}
              </button>
            </div>
          </div>

          <button
            class="border-l border-slate-200 bg-slate-100/95 px-5 text-sm font-medium text-slate-700 whitespace-nowrap transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
            type="submit"
            [disabled]="inFlight()"
          >
            @if (inFlight()) {
              <span
                class="block h-4 w-4 animate-spin rounded-full border-2 border-slate-400/30 border-t-slate-600"
              ></span>
            } @else {
              Reset
            }
          </button>
        </div>

        @if (mismatchError()) {
          <p class="mt-2 text-center text-xs text-rose-300">
            Passwords do not match.
          </p>
        } @else if (showNewPasswordError()) {
          <p class="mt-2 text-center text-xs text-rose-300">
            Password does not meet all requirements.
          </p>
        }

        <div
          class="mt-3 flex items-center justify-between text-xs text-white/75"
        >
          <button
            type="button"
            class="transition hover:text-white"
            (click)="goToForgotPassword()"
          >
            Request a new link
          </button>
          <a
            class="transition hover:text-white"
            href="mailto:support@aksia.com"
          >
            Contact support
          </a>
        </div>
      </form>
    } @else if (outcome() === 'success') {
      @if (redirectUrl()) {
        <p class="max-w-xs text-center text-sm font-medium text-white">
          Password reset successfully.
        </p>
        <p class="mt-2 max-w-xs text-center text-sm text-white/80">
          Sign in with your new password to continue. Taking you there in
          {{ secondsUntilRedirect() }}
          {{ secondsUntilRedirect() === 1 ? 'second' : 'seconds' }}.
        </p>
        <button
          type="button"
          class="mt-5 rounded-lg bg-slate-100/95 px-6 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-200"
          (click)="redirectNow()"
        >
          Sign in now
        </button>
      } @else {
        <p class="max-w-xs text-center text-sm font-medium text-white">
          Password reset successfully.
        </p>
        <p class="mt-2 max-w-xs text-center text-sm text-white/80">
          Open the application you were using and sign in with your new
          password.
        </p>
      }

      <div class="mt-5 flex gap-6 text-xs text-white/75">
        <a class="transition hover:text-white" href="mailto:support@aksia.com">
          Contact support
        </a>
      </div>
    } @else if (outcome() === 'failed') {
      <p class="max-w-xs text-center text-sm text-white/80">
        {{ failureMessage() }}
      </p>
      <button
        type="button"
        class="mt-5 rounded-lg bg-slate-100/95 px-6 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-200"
        (click)="retryReset()"
      >
        Try again
      </button>
    } @else if (outcome() === 'expired') {
      <p class="max-w-xs text-center text-sm text-white/80">
        This link is no longer valid. It may have expired or already been used.
        Reset links are valid for 30 minutes and can only be used once.
      </p>
      <button
        type="button"
        class="mt-5 rounded-lg bg-slate-100/95 px-6 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-200"
        (click)="goToForgotPassword()"
      >
        Request a new link
      </button>
    }
  </div>

  <footer
    class="absolute bottom-0 w-full py-4 text-center text-xs text-white/40"
  >
    <a class="transition hover:text-white/70" href="mailto:support@aksia.com">
      Contact support
    </a>
  </footer>
</div>
